import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_ACTIVE_LIST_FOR_OPTION_PMS = graphql(/* GraphQL */ `
	query OptionPmsActiveListForOptionPms($hotelID: ID!, $date: String!) {
		optionPmsActiveList(hotelID: $hotelID, date: $date) {
			id
			options {
				id
				hotelID
				itemType
				reservationID
				uniqueID
				date
				guestName
				guestTel
				optionID
				subOptionID
				optionName
				subOptionName
				amount
				optionStartAt
				optionEndAt
				paymentMethod
				planName
				roomNum {
					adultNum
					kidsNum {
						age
						asCosleeping
					}
					uniqueRoomID
				}
				questions {
					question
					answer
				}
				memo
				canDelete
				isCanceled
			}
		}
	}
`);
